export default "__VITE_ASSET__B$eJgSgD__"